import { create } from "zustand";

export const useMembershipStore = create((set) => ({
  membershipList: {},
  displayMembershipList: [],
  membershipBundleByListingId: {},
  isCarouselMove: false,
  isOpenPerksAddEditModal: false,
  isOpenCreateMembershipTierModal: false,
  isOpenSettingModal: false,
  isOpenDeleteConfirmation: false,
  isOpenChannelListModal: false,
  isOpenLinkListModal: false,
  isOpenKycModal: false,
  isMembershipListLoading: false,
  membershipTierDetails: {},
  editedMembershipKeys: [],
  editedPerkData: { text: "", index: null },
  listingId: "",
  selectedRecord: null,
  canFetchMembershipList: false,
  isClicked: false,
  initialMappedCustomLinks: [],
  setIsMembershipListLoading: (val) => set({ isMembershipListLoading: val }),
  setMembershipList: (val) => set({ membershipList: val }),
  setDisplayMembershipList: (val) => set({ displayMembershipList: val }),
  setMembershipBundleByListingId: (key, val) =>
    set((state) => ({
      membershipBundleByListingId: {
        ...state.membershipBundleByListingId,
        [key]: val,
      },
    })),
  setisCarouselMove: (val) => set({ isCarouselMove: val }),
  setIsOpenPerksAddEditModal: (val) => set({ isOpenPerksAddEditModal: val }),
  setIsOpenChannelListModal: (val) => set({ isOpenChannelListModal: val }),
  setIsOpenLinkListModal: (val) => set({ isOpenLinkListModal: val }),
  setIsOpenKycModal: (val) => set({ isOpenKycModal: val }),
  setIsOpenCreateMembershipTierModal: (val) =>
    set({ isOpenCreateMembershipTierModal: val }),
  setIsOpenSettingModal: (val) => set({ isOpenSettingModal: val }),
  setIsOpenDeleteConfirmation: (val) => set({ isOpenDeleteConfirmation: val }),
  initialiseMemberTierDetails: (val) => set({ membershipTierDetails: val }),
  setMembershipTierDetails: (key, val) =>
    set((state) => ({
      membershipTierDetails: { ...state.membershipTierDetails, [key]: val },
    })),
  setEditedMembershipKeys: (val) => set({ editedMembershipKeys: val }),
  updateEditedMembershipKeys: (val) =>
    set((state) => {
      if (!state.editedMembershipKeys.includes(val)) {
        return { editedMembershipKeys: [...state.editedMembershipKeys, val] };
      }
    }),
  setEditedPerkData: (val) => set({ editedPerkData: val }),
  setListingId: (val) => set({ listingId: val }),
  setSelectedRecord: (val) => set({ selectedRecord: val }),
  setCanFetchMembershipList: (val) => set({ canFetchMembershipList: val }),
  setIsClicked: (val) => set({ isClicked: val }),
  setInitialMappedCustomLinks: (val) => set({ initialMappedCustomLinks: val }),
}));
